// Others.
import Pusher from 'pusher-js'
import { repositoryFactory } from '@/repositories/repositoryFactory'

export default {
    beforeDestroy() {
        this.pusher.disconnect()
    },
    created() {
        this._connect()
    },
    data: () => ({
        pusher: null,
    }),
    methods: {
        _connect() {
            this.pusher = new Pusher(process.env.VUE_APP_WS_APP_KEY, {
                wsHost: process.env.VUE_APP_WS_HOST,
                wsPort: process.env.VUE_APP_WS_PORT,
                forceTLS: false,
                enabledTransports: ['ws'],
                authorizer: (channel) => ({
                    authorize: (socketId, callback) => {
                        const repository = repositoryFactory.get('conectaSus.websocket')

                        repository.login({
                                token: socketId + ':' + channel.name
                            })
                            .then(response => callback(null, { auth: response }))
                            .catch(error => console.error(error))
                    }
                })
            })
        },
    },

}